import _ from 'lodash';
import { MarketingCampaignDiscount, MarketingCampaignDiscountType, Offer, } from '../1_types/genericTypes';
import { isStringNotNull } from './dataType';
import store from '../redux/store';
import { delay } from './common';
import { roundNumber } from './order';

export const getMarketingCampaignPromotionAmount = (
  price: number,
  nb: number,
  discount: MarketingCampaignDiscount
): number => {
  const priceCents = Math.round(price * 100);
  let discountCents: number;

  if (discount.type === MarketingCampaignDiscountType.PERCENTAGE) {
    discountCents = Math.round((priceCents * discount.value) / 100);
  } else {
    discountCents = Math.round(discount.value * 100) * nb;
  }
  return discountCents / 100;
};

export const createCategoriesFromOffers = async (
  offers: Offer[]
): Promise<{ [key: string]: any }> => {
  const { sections } = store.getState().shopReducer;

  if (_.isEmpty(sections)) {
    await delay(1000);
    return createCategoriesFromOffers(offers);
  }

  const categories = {};

  for (const offer of offers) {
    if (!offer.config.products?.length) continue;

    const productSectionProductOfferedMap = {};

    for (const productConfig of offer.config.products) {
      const productOffered = _.find(
        sections,
        (section) => section.key === productConfig.productOfferedSectionKey
      )?.products[productConfig.productOfferedKey];
      if (
        !(
          isStringNotNull(productConfig.productOfferedKey) &&
          isStringNotNull(productConfig.productOfferedSectionKey) &&
          productOffered
        )
      ) {
        continue;
      }

      const key = `${productConfig.productSectionKey}__${productConfig.productKey}`;

      const productOfferedInfo = {
        productOfferedKey: productConfig.productOfferedKey,
        productOfferedSectionKey: productConfig.productOfferedSectionKey,
        productOffered,
      };

      productSectionProductOfferedMap[key] = productSectionProductOfferedMap[
        key
      ]
        ? _.uniqBy(
          [...productSectionProductOfferedMap[key], productOfferedInfo],
          (productOffered: any) =>
            `${productOffered.productOfferedKey}__${productOffered.productOfferedSectionKey}`
        )
        : [productOfferedInfo];
    }

    for (const productSection of Object.keys(productSectionProductOfferedMap)) {
      const categoryKey = `${offer.key}__${productSection}`;
      const items = {};
      let position = 0;
      for (const productOffered of productSectionProductOfferedMap[
        productSection
      ]) {
        const itemKey = `${productOffered.productOfferedKey}__${productOffered.productOfferedSectionKey}`;
        const product = productOffered.productOffered;
        items[itemKey] = {
          categoryKey,
          isFree: true,
          key: itemKey,
          name: product.name,
          position,
          price: 0,
          priceRef: product.priceRef,
          productKey: productOffered.productOfferedKey,
          ref: product?.ref,
          subcategories: product.categories,
        };
        position++;
      }
      categories[categoryKey] = {
        id: categoryKey,
        key: categoryKey,
        max: 1,
        min: 1,
        multiple: false,
        name: 'Produit Offert',
        path: null,
        ref: null,
        isMarketingCampaignProductOffered: true,
        items,
      };
    }
  }

  return categories;

};

const computeDiscountedUnitPrice = (
  unitPrice: number,
  totalPrice: number,
  quantity: number,
  discount: any
): number => {
  let discountedPrice = Math.max(0, unitPrice);

  const discountAmount = getMarketingCampaignPromotionAmount(
    discountedPrice,
    1,
    discount
  );

  discountedPrice = Math.max(0, discountedPrice - discountAmount);

  if (totalPrice > 0) {
    const extraCostPerUnit = Math.max(0, totalPrice / quantity - unitPrice);
    discountedPrice += extraCostPerUnit;
  }

  return discountedPrice;
};

export const getProductTempPrice = (
  product: any,
  productOffer: any,
  ignoreTempPrice = false
) => {
  const {
    price = 0,
    totalPrice = 0,
    nb = 1,
    key,
    sectionKey
  } = product;

  const { thresholdOffer } = store.getState().offerReducer;
  const { totalProductPriceWithPromo = 0 } =
    store.getState().pendingOrderReducer;

  let unitPrice = Math.max(0, totalPrice || price);
  if (
    productOffer?.config?.discount?.type === MarketingCampaignDiscountType.PERCENTAGE &&
    !productOffer.config?.threshold
  ) {
    unitPrice = computeDiscountedUnitPrice(
      price,
      totalPrice,
      nb,
      productOffer.config.discount
    );
  }
  if (
    thresholdOffer?.config?.discount?.type === MarketingCampaignDiscountType.PERCENTAGE &&
    totalProductPriceWithPromo +
    (ignoreTempPrice ? 0 : unitPrice) >= thresholdOffer.config.threshold &&
    (
      !thresholdOffer.config.products ||
      _.find(
        thresholdOffer.config.products,
        p =>
          p.productKey === key &&
          p.productSectionKey === sectionKey
      )
    )
  ) {
    unitPrice = computeDiscountedUnitPrice(
      price,
      totalPrice,
      nb,
      thresholdOffer.config.discount
    );
  }

  return roundNumber(Math.max(0, unitPrice * nb));
};
